// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useTranslation } from 'react-i18next';

import { TextField } from '../../../../../atoms';
import { useCurrentPaymentTypeOptionalFields } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

type Props = {
  rootStyle?: {},
  fieldName: string,
};

export function FieldStreetComplement({ rootStyle, fieldName }: Props): Node {
  const inputId = useUniqueId();
  const [value, handleChange] = useUserInputAsTextField(fieldName);
  const submitting = useSubmitting();

  const isOptionalFieldByStreetNumber = useCurrentPaymentTypeOptionalFields('street_number');
  const isOptionalFieldByAddress = useCurrentPaymentTypeOptionalFields('address');

  if (isOptionalFieldByAddress || isOptionalFieldByStreetNumber) {
    return null;
  }

  return (
    <div style={rootStyle} data-test-name="address-street-complement">
      <label htmlFor={inputId}>
        <StreetComplementLabel />
      </label>

      <TextField
        id={inputId}
        value={value}
        onChange={handleChange}
        placeholder="Opcional"
        readOnly={submitting}
        name="address-street-complement"
      />

    </div>
  );
}

function StreetComplementLabel(): Node {
  const { t } = useTranslation('opened-page');
  return t('volcanes.form.streetComplement.label');
}
